module.exports = __webpack_public_path__ + "media/images/pc/articles/report_deco-fb9ed166ce8cb7c45fbe4974ddd2088f.webp";